// Imports
import React, { useState } from "react"
import { Icon } from "fajny-react"
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs"
import { CopyToClipboard } from "react-copy-to-clipboard"

import { Container, Code, Button } from "./styles"

const CodeContainer = ({ language = "javascript", children, button = true, ...props }) => {
    const [hasCopied, setHasCopied] = useState(false)

    setTimeout(() => {
        hasCopied && setHasCopied(false)
    }, 1000)

    return (
        <Container>
            <Code style={atomOneDark} language={language} {...props}>
                {children}
            </Code>

            {button && (
                <CopyToClipboard text={children}>
                    <Button onClick={() => setHasCopied(true)} $hasCopied={hasCopied}>
                        <Icon src={hasCopied ? "check-solid" : "clipboard-solid"} size={24} />
                    </Button>
                </CopyToClipboard>
            )}
        </Container>
    )
}

export default CodeContainer
